import axios from 'axios'

export default {
  state: {
    academy_list: [],
    academy_section: null,
    academy_neighbors: [],
  },
  getters: {
    getAcademyList: (s) => s.academy_list,
    getAcademySection: (s) => s.academy_section,
    getAcademyNeighbors: (s) => s.academy_neighbors,
  },
  mutations: {
    setAcademyList: (s, list) =>
      (s.academy_list = list.filter((el) => el.translates.length)),
    setAcademySection: (s, section) => (s.academy_section = section),
    setAcademyNeighbors: (s, neighbors) => (s.academy_neighbors = neighbors),
  },
  actions: {
    fetchAcademyList(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `/api/v3/success-academy/items/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setAcademyList', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchAcademySection(ctx, { lang = 'ru', slug }) {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `/api/v3/success-academy/items/${slug}/?language=${lang}`,
      })
        .then((response) => {
          const section = response.data
          ctx.commit('setAcademySection', section)
        })
        .catch((error) => {
          ctx.commit('setAcademySection', error.response.status)
          console.error(error)
        })
    },
    fetchAcademyNeighbors(ctx, { slug, lang = 'ru' }) {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `/api/v3/success-academy/items/${slug}/neighbors/?language=${lang}`,
      })
        .then((response) => {
          const neighbors = response.data
          ctx.commit('setAcademyNeighbors', neighbors)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    clearAcademyNeighbors(ctx) {
      ctx.commit('setAcademyNeighbors', [])
    },
    academySetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/success-academy/elements/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    academySetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/success-academy/elements/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    academySetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/success-academy/elements/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    academySetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/success-academy/elements/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
